export default __webpack_public_path__ + "static/media/FirstScreen.8a8c03f4.png";